<template>
  <table class="tsw-table-article cus-addable-table-v2" :name="options.Key">
    <colgroup>
      <col style="width: 50px">
      <col v-for="(head, i) in options.TableHeads" :key="i" :style="`width: ${head.Width || 'initial'}`" >
      <col style="width: 100px">
    </colgroup>
    <tbody>
      <tr class="cus-table-thead">
        <th v-for="(head, i) in options.TableHeads" :key="i" :colspan="i ? 1 : 2">
          {{head.Name}}
        </th>
        <th>操作</th>
      </tr>
      <template v-for="(obj, i) in options.TableColumns" :key="i">
        <template v-if="form[options.Key]">
          <tr v-for="(o, j) in rows[obj.Key]" :key="j">
            <template v-if="!j">
              <td :rowspan="rows[obj.Key].length" style="width: 50px;vertical-align: middle">
                <p>{{i + 1}}</p>
              </td>
              <td :rowspan="rows[obj.Key].length" style="vertical-align: middle">
                <p>
                  {{obj.Name}}
                  <br>
                  <el-button type="primary" size="small" @click="addRow(i)">添加</el-button>
                </p>
              </td>            
            </template>
            <td v-for="(v, k) in obj.Children" :key="k" :style="{textAlign: v.Align}">
              <p v-if="o.editable" class="cat-p">
                <el-form-item v-msg class="tender-form-label" label-width="0" :prop="`${options.Key}.${obj.Key}[${j}].${v.Key}`" :name="v.Key" :rules="xrules[obj.Key][v.Key]">
                  <bear-input 
                    v-model="o[v.Key]" 
                    @input="inputChangeHandle"
                  ></bear-input>
                </el-form-item>
              </p>
              <p v-else>{{o[v.Key]}}</p>
            </td>
            <td>
              <p>
                <el-button v-if="j && o.editable" type="danger" size="small" @click="delRow(i, j)">删除</el-button>
              </p>
            </td>
          </tr>          
        </template>
      </template>
    </tbody>
  </table>
</template>
<script>
import { mixForFormItem } from '../../../js/mixins'
import utils from '../../../js/utils'
import formUtils from '../../../js/formUtils'
import BearInput from '~@/input/src'
export default {
  name: 'FormAddableTableV2',
  components: {
    BearInput,
  },
  mixins: [mixForFormItem],
  computed: {
    xrules() {
      let {TableColumns = []} = this.options
      let resRules = {}
      TableColumns.forEach((column) => {
        let rules = {}
        column.Children.forEach((obj) => {
          rules[obj.Key] = formUtils.initFormRules(obj, this.form, this.param)
        })
        resRules[column.Key] = rules
      })
      return resRules
    },
    requiredColumns() {
      let {rows} = this
      let {TableColumns = []} = this.options
      let count = 0
      TableColumns.forEach((obj, i) => {
        count += rows[obj.Key].filter(obj => obj.editable).length * obj.Children.filter(obj => obj.Required !== false).length
      })
      return count
    },
    value() {
      let {options, form} = this
      return form[options.Key]
    }
  },
  data() {
    return {
      rows: {}
    }
  },
  created() {
    this.setDefaultValue()
  },
  methods: {
    setDefaultValue() {
      let {form = {}, options} = this
      utils.readyToSetFormItemDefault(form, options).then(() => {
        if(options.Value) {
          form[options.Key] = options.Value
          this.rows = options.Value
        } else {
          let {TableColumns} = options
          form[options.Key] = this.rows
          TableColumns.forEach(({Key}, i) => {
            this.rows[Key] = []
            this.addRow(i, true)
          })
        }
        this.$nextTick(() => {
          this.doValidate()
        })
      }).catch(() => {
        this.rows = form[options.Key]
        this.$nextTick(() => {
          this.doValidate()
        })
      })
    },
    addRow(index, first) {
      let {TableColumns = []} = this.options
      let {Children, Key} = TableColumns[index]
      let row = {}
      Children.forEach(column => {
        row[column.Key] = ''
      })
      row.editable = true
      this.rows[Key].push(row)
      this.$nextTick(() => {
        first || this.doValidate()
      })
    },
    delRow(index, j) {
      let {Key} = this.options.TableColumns[index]
      this.rows[Key].splice(j, 1)
      this.$nextTick(() => {
        this.doValidate()
      })
    },
    inputChangeHandle() {
      this.doValidate()
    },
    getRequiredCount() {
      return this.requiredColumns
    }
  },
  watch: {
    value() {
      this.rows = this.value
      this.$nextTick(() => {
        this.doValidate()
      })
    }
  }
}
</script>
<style lang="scss">
.cus-addable-table-v2 {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  thead, .cus-table-thead {
    background: #EEF1F6;
  }
  th, td {
    padding: 10px;
    vertical-align: top;
    border: 1px solid #DFE6EC
  }
  .text-left {
    text-align: left;
  }
  .cat-p {
    margin: 10px 0;
    .el-form-item {
      display: inline;
      margin-right: 0;
    }
  }
  .el-form-item--default, .el-form-item {
    .el-form-item__content {
      display: inline;
    }
  }
}
</style>